import BaseService from '@/services/BaseService';
const ATLAS_MAPPINGS_BASE = 'atlas-mappings-pivoted';

/** UI / API path segment for pivoted atlas mappings SSRM grids. */
export type AtlasMappingsAssetClass =
  | 'auto'
  | 'credit-card'
  | 'consumer-unsecured-non-marketplace'
  | 'consumer-unsecured-marketplace'
  | 'energy'
  | 'energy-ci'
  | 'student-loan';

export type AtlasMappingColumnMeta = {
  field: string;
  headerName: string;
  group?: string | null;
};

function resolvePathSegment(assetClass: AtlasMappingsAssetClass): string {
  return assetClass;
}

/** HTTP client for `atlas-mappings-pivoted/{assetClass}` column metadata and SSRM grids. */
export class AtlasMappingsService extends BaseService {
  constructor() {
    super('/api/digitalconnect-service');
  }

  resolveColumnsPath = (assetClass: AtlasMappingsAssetClass = 'auto'): string => {
    const segment = resolvePathSegment(assetClass);
    return `${ATLAS_MAPPINGS_BASE}/${segment}/columns`;
  };

  resolveSsrmEndpoint = (assetClass: AtlasMappingsAssetClass = 'auto'): string => {
    const segment = resolvePathSegment(assetClass);
    return `${ATLAS_MAPPINGS_BASE}/${segment}`;
  };

  fetchColumns = async (assetClass: AtlasMappingsAssetClass = 'auto'): Promise<AtlasMappingColumnMeta[]> => {
    const response = await this.get({ path: this.resolveColumnsPath(assetClass) });
    return Array.isArray(response) ? response : [];
  };
}
